import styled from 'styled-components';

export const TagFieldWrapper = styled.div`
    display: flex;
`;

export const TagButtonWrapper = styled.div`
    margin-top: 25px;
`;